import React, { useEffect } from "react";
import "../styles/components/modal.css";

const Modal = ({ isOpen, message, itemTitle, onCancel, onConfirm }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }

    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <p className="modal-message">{message}</p>
        {itemTitle && <p className="modal-item-title">"{itemTitle}"</p>}
        <div className="modal-buttons">
          <button
            className="modal-button cancel-button"
            onClick={onCancel}
          >
            Отмена
          </button>
          <button
            className="modal-button ok-button"
            onClick={onConfirm}
          >
            ОК
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;